import React,{ useState } from "react";

const About = () => {
  const [openIndex, setOpenIndex] = useState(0); 

  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const data = [
    {
      question: "01. What curriculum does the school follow?",
      answer:
        "Our school follows a well-rounded and modern curriculum that meets national educational standards while promoting critical thinking, creativity, and lifelong learning.",
    },
    {
      question: "02. Are there extracurricular activities available?",
      answer:
        "Yes! We offer a wide range of extracurriculars such as sports, music, drama, art, coding clubs, and more to help students explore their passions beyond academics.",
    },
    {
      question: "03. How does the school support individual learning needs?",
      answer:
        "We provide personalized support through small class sizes, learning assessments, tutoring, and tailored academic plans to ensure every student can succeed at their own pace.",
    },
  ];
  return (
    <div>
      {/* Inner Page */}
      <div className="inner-banner py-5">
        <section className="w3l-breadcrumb text-left py-sm-5">
          <div className="container">
            <div className="w3breadcrumb-gids">
              <div className="w3breadcrumb-left text-left">
                <h2 className="inner-w3-title mt-sm-5 mt-4">About Us</h2>
              </div>
              <div className="w3breadcrumb-right">
                <ul className="breadcrumbs-custom-path">
                  <li>
                    <a href="/Home">Home</a>
                  </li>
                  <li className="active">
                    <span className="fas fa-angle-double-right mx-2"></span>{" "}
                    About Us
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* End Inner Page */}

      {/* About Us Section */}
      <section className="w3l-passion-mid-sec py-5">
        <div className="container py-md-5 py-3">
          <div className="row w3l-passion-mid-grids">
            <div className="col-lg-6 passion-grid-item-info pe-lg-5 mb-lg-0 mb-5">
              <h6 className="title-subw3hny mb-1">About Our Company</h6>
              <h3 className="title-w3l mb-4">
                Empowering Students to Reach Their Full Potential
              </h3>
              <p className="mt-3 pe-lg-5">
                We are dedicated to nurturing every student's unique strengths
                by providing a supportive, engaging, and inclusive learning
                environment. Through innovative teaching, personalized guidance,
                and holistic development opportunities, we help students grow
                academically, emotionally, and socially—preparing them to thrive
                in the real world.
              </p>
            </div>
            <div className="col-lg-6 w3hny-passion-item">
              <div className="row">
                <div className="col-6 passion-grid-item-pic">
                  <img
                    src="assets/images/1.png"
                    alt=""
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "250px",
                    }}
                    className="img-fluid radius-image"
                  />
                </div>
                <div className="col-6 passion-grid-item-pic">
                  <img
                    src="assets/images/22.jpg"
                    alt=""
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "250px",
                    }}
                    className="img-fluid radius-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Progress Bars Section */}
      <section
        className="w3l-servicesblock w3l-servicesblock1 py-5"
        id="progress"
        style={{ backgroundColor: "#D0D8FF" }}
      >
        <div className="container py-lg-5 py-md-4 py-2">
          <div className="row">
            <div className="col-lg-6 align-self pe-lg-4">
              <div className="progress-info info1">
                <h6 className="progress-tittle">
                  Professionality <span className="">70%</span>
                </h6>
                <div className="progress">
                  <div
                    className="progress-bar progress-bar-striped"
                    role="progressbar"
                    style={{ width: "70%" }}
                    aria-valuenow="70"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
              </div>
              <div className="progress-info info2">
                <h6 className="progress-tittle">
                  Guarantee<span className="">80%</span>
                </h6>
                <div className="progress">
                  <div
                    className="progress-bar progress-bar-striped"
                    role="progressbar"
                    style={{ width: "80%" }}
                    aria-valuenow="80"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
              </div>
              <div className="progress-info info3">
                <h6 className="progress-tittle">
                  Key Of Success<span className="">90%</span>
                </h6>
                <div className="progress">
                  <div
                    className="progress-bar progress-bar-striped"
                    role="progressbar"
                    style={{ width: "90%" }}
                    aria-valuenow="90"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 mt-lg-0 mt-5 ps-lg-5">
              <h5 className="title-subw3hny mb-1">Progress Bars</h5>
              <h3 className="title-w3l">
                Doing the right thing, at the right time.
              </h3>
              <p className="mt-md-4 mt-3">
                Success comes from making smart choices with purpose and timing.
                We believe in guiding students and communities to act with
                integrity, take initiative, and make thoughtful decisions that
                lead to lasting impact.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w3l-products w3l-faq-block py-5" id="projects">
        <div className="container py-lg-5">
          <div className="row">
            <div className="col-lg-6 w3hny-passion-item pe-lg-5">
              <img
                src="assets/images/1.png"
                alt=""
                className="img-fluid radius-image"
              />
            </div>
            <div className="col-lg-6 mt-lg-0 mt-sm-5 mt-5">
              <h6 className="title-subw3hny mb-1">Ask by Client</h6>
              <h3 className="title-w3l mb-4">Frequently Asked Questions</h3>

              <div className="accordion" id="accordionExample">
                {data.map((item, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className={`accordion-button ${
                          openIndex === index ? "" : "collapsed"
                        }`}
                        type="button"
                        onClick={() => toggleAccordion(index)}
                        aria-expanded={openIndex === index}
                      >
                        {item.question}
                       {/* <i
                          className="fas fa-chevron-down ms-auto"
                          style={{
                            transition: "transform 0.3s ease",
                            transform:
                              openIndex === index
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                          }}
                        ></i>*/}
                      </button>
                    </h2>
                    <div
                      className={`accordion-collapse collapse ${
                        openIndex === index ? "show" : ""
                      }`}
                    >
                      <div className="accordion-body">{item.answer}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Subscribe Content Section */}
      <section className="w3l-join-main py-5">
        <div className="container py-md-5">
          <div className="w3l-project-in">
            <div className="row">
              <div className="col-lg-4 col-12">
                <div className="bottom-info">
                  <div className="header-section pe-lg-5">
                    <h5 className="title-subw3hny mb-lg-2">Some Info</h5>
                    <h3 className="title-w3l two mb-2">
                      Industrial Services For Your Business
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 align-self mt-lg-0 mt-3">
                <p>
                  We offer reliable and customized industrial solutions designed
                  to enhance productivity, ensure operational efficiency, and
                  support the growth of your business. From maintenance to
                  process optimization, our expert team is here to meet your
                  unique needs.
                </p>
              </div>
              <div className="col-lg-4 col-md-6 align-self mt-lg-0 mt-3">
                <p>
                  We provide end-to-end industrial services tailored to meet the
                  unique demands of modern businesses. Our offerings include
                  equipment installation, preventative maintenance, process
                  automation, safety inspections, and operational consulting.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/*<section className="w3l-team-main team py-5" id="team">
        <div className="container py-lg-5">
          <div className="title-content text-center mb-2">
            <h6 className="title-subw3hny mb-1">Our Team</h6>
            <h3 className="title-w3l">Who Worked With Us.</h3>
          </div>
          <div className="row team-row justify-content-center">
         
            <div className="col-lg-4 col-6 team-wrap mt-lg-5 mt-4">
              <div className="team-member text-center">
                <div className="team-img">
                  <img
                    src="assets/images/team1.jpg"
                    alt=""
                    className="radius-image"
                  />
                  <div className="overlay-team">
                    <div className="team-details text-center">
                      <div className="socials mt-20">
                        <a href="#url">
                          <span className="fab fa-facebook-f"></span>
                        </a>
                        <a href="#url">
                          <span className="fab fa-twitter"></span>
                        </a>
                        <a href="#url">
                          <span className="fab fa-linkedin-in"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <a href="#url" className="team-title">
                  Lawrence Petrie
                </a>
                <p>Director</p>
              </div>
            </div>
          
          
            <div className="col-lg-4 col-6 team-wrap mt-lg-5 mt-4">
              <div className="team-member text-center">
                <div className="team-img">
                  <img
                    src="assets/images/team2.jpg"
                    alt=""
                    className="radius-image"
                  />
                  <div className="overlay-team">
                    <div className="team-details text-center">
                      <div className="socials mt-20">
                        <a href="#url">
                          <span className="fab fa-facebook-f"></span>
                        </a>
                        <a href="#url">
                          <span className="fab fa-twitter"></span>
                        </a>
                        <a href="#url">
                          <span className="fab fa-linkedin-in"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <a href="#url" className="team-title">
                  Jack Peters
                </a>
                <p>Managing Director</p>
              </div>
            </div>
           
            <div className="col-lg-4 col-6 team-wrap mt-lg-5 mt-4">
              <div className="team-member text-center">
                <div className="team-img">
                  <img
                    src="assets/images/team3.jpg"
                    alt=""
                    className="radius-image"
                  />
                  <div className="overlay-team">
                    <div className="team-details text-center">
                      <div className="socials mt-20">
                        <a href="#url">
                          <span className="fab fa-facebook-f"></span>
                        </a>
                        <a href="#url">
                          <span className="fab fa-twitter"></span>
                        </a>
                        <a href="#url">
                          <span className="fab fa-linkedin-in"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <a href="#url" className="team-title">
                  Anna Phillips
                </a>
                <p>Worker</p>
              </div>
            </div>
         
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default About;
